import Swal from "sweetalert2";

export const GetDocumentpo = (target, setDocumento) => {
  var result = {
    documento: "",
    extension: "",
  };
  if (
    target.files === undefined ||
    target.files === null ||
    target.files.length === 0
  ) {
    setDocumento(result);
    return;
  }
  const file = target.files[0].name.split(".");
  if (file.length > 2) {
    Swal.fire("Clientes", "Archivo invalido", "error");
    setDocumento(result);
    return;
  }

  if (file[1] !== "jpg" && file[1] !== "jepg" && file[1] !== "pdf") {
    Swal.fire(
      "Clientes",
      "Archivo con formato no valido. Formatos validos(jpd - jepg , pdf)",
      "error"
    );
    target.value = "";
    setDocumento(result);
    return;
  }

  var fReader = new FileReader();
  fReader.readAsDataURL(target.files[0]);
  fReader.onloadend = function (event) {
    setDocumento({
        documento:event.target.result,
        extension:file[1]
    })
  };
  setDocumento(result);
};
